import * as apiDelete from 'api/apiKey/DeleteApiKeyIdV1';
import * as apiPost from 'api/apiKey/PostApiKeyGenerateV1';
import * as apiPut from 'api/apiKey/PutApiKeyIdV1';
import * as apiGetUserProfile from 'api/userProfile//GetUserProfileV1';
import * as SimpleDate from 'types/_general/SimpleDate';

export type Type = {
	id: string;
	displayName: string;
	expirationTime: Date | null;
	secretKey?: string;
};

export function create(): Type {
	return {
		id: '',
		displayName: '',
		expirationTime: new Date(),
	};
}

export function mapFromApi(request: apiGetUserProfile.UserApiKey[]): Type[] {
	return request.map((apiKey: apiGetUserProfile.UserApiKey): Type => {
		return {
			id: apiKey.id,
			displayName: apiKey.displayName,
			expirationTime: new Date(apiKey.expirationTime),
		};
	});
}

export function changeName(apiKey: Type, name: string): Type {
	return { ...apiKey, displayName: name };
}

export function changeSecretKey(apiKey: Type, secretKey: string): Type {
	return { ...apiKey, secretKey: secretKey };
}

export async function deleteFromApi(id: string): Promise<void> {
	await apiDelete.callApi(id);
}

export async function saveToApi(obj: Type): Promise<Type> {
	await apiPut.callApi(obj.id, {
		displayName: obj.displayName,
		expirationTime: obj.expirationTime ? obj.expirationTime.toISOString() : null,
	});
	return { ...obj };
}

export async function generateToApi(obj: Type): Promise<Type> {
	const response = await postToApi(obj);
	if (!response.id || !response.key) return create();
	return { ...obj, id: response.id, secretKey: response.key };
}

export async function postToApi(obj: Type): Promise<apiPost.ResponseData> {
	const response = await apiPost.callApi({
		displayName: obj.displayName,
		expirationTime: obj.expirationTime ? obj.expirationTime.toISOString() : null,
	});
	return response.getOrDefault({} as apiPost.ResponseData);
}

export function getExpirationTimeString(obj: Type): string {
	return obj.expirationTime ? SimpleDate.toInputFieldDate(obj.expirationTime) : '';
}
